// src/components/Header.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaWater,
  FaMap,
  FaBook,
  FaInfoCircle,
  FaDatabase,
  FaBars,
  FaTimes,
} from 'react-icons/fa';

import logo from '../images/IWMI_Logo.png';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const getLinkClass = (path) =>
    location.pathname === path ? 'nav-link active' : 'nav-link';

  const toggleMenu = () => setMenuOpen((open) => !open);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className="header">
        <div className="header-left">
          <img src={logo} alt="IWMI Logo" className="logo" />
        </div>

        <div className="header-center">
          <h1 className="header-title">DIWASA Portfolio</h1>
          <p className="header-subtitle">
            (Digital Innovations for Water Secure Africa)
          </p>
        </div>

        {/* Desktop nav */}
        <nav className="nav-links nav-links-desktop">
          <Link to="/" className={getLinkClass('/')}>
            <FaHome className="nav-icon" /> Home
          </Link>
          <Link to="/diwasa" className={getLinkClass('/diwasa')}>
            <FaWater className="nav-icon" /> DIWASA
          </Link>
          <Link to="/about" className={getLinkClass('/about')}>
            <FaInfoCircle className="nav-icon" /> About Us
          </Link>
          <Link to="/map" className={getLinkClass('/map')}>
            <FaMap className="nav-icon" /> Portfolio
          </Link>
          <Link to="/resources" className={getLinkClass('/resources')}>
            <FaBook className="nav-icon" /> Resources
          </Link>
          <Link
            to="/requestdataaccess"
            className={getLinkClass('/requestdataaccess')}
          >
            <FaDatabase className="nav-icon" /> Request Data Access
          </Link>
        </nav>

        {/* Mobile menu button */}
        <button
          className="mobile-menu-toggle"
          type="button"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </header>

      {/* Mobile drawer + backdrop */}
      <div
        className={`mobile-drawer-backdrop ${
          menuOpen ? 'mobile-drawer-backdrop--open' : ''
        }`}
        onClick={closeMenu}
      >
        <nav
          className={`mobile-drawer ${menuOpen ? 'mobile-drawer--open' : ''}`}
          onClick={(e) => e.stopPropagation()} // don’t close when clicking inside the drawer
        >
          <div className="mobile-drawer-header">
            <span>Menu</span>
          </div>

          <Link to="/" className={getLinkClass('/')}>
            <FaHome className="nav-icon" /> Home
          </Link>
          <Link to="/diwasa" className={getLinkClass('/diwasa')}>
            <FaWater className="nav-icon" /> DIWASA
          </Link>
          <Link to="/about" className={getLinkClass('/about')}>
            <FaInfoCircle className="nav-icon" /> About Us
          </Link>
          <Link to="/map" className={getLinkClass('/map')}>
            <FaMap className="nav-icon" /> Portfolio
          </Link>
          <Link to="/resources" className={getLinkClass('/resources')}>
            <FaBook className="nav-icon" /> Resources
          </Link>
          <Link
            to="/requestdataaccess"
            className={getLinkClass('/requestdataaccess')}
          >
            <FaDatabase className="nav-icon" /> Request Data Access
          </Link>
        </nav>
      </div>
    </>
  );
};

export default Header;
